const translation = {
    confirm: '本気ですか？',
    common: { back: '戻る' },
    save: '保存',
    returnToGame: 'ゲームに戻ってもよろしいですか?',
    yes: 'はい',
    no: 'いいえ',
    login: {
        auth: '認可',
        noAcc: 'アカウントがありません',
        reg: '登録する',
        mail: 'メールでログインする',
        registration: '登録',
        agreement: '「登録」ボタンをクリックすると、個人データの処理に同意したことを',
        agreementLink: '表示したことになります。',
        submit: '登録する',
        continue: '続行',
        emailLabel: 'Eメール',
        passwordLabel: 'パスワード',
        repeatPasswordLabel: 'パスワードを再度入力してください。',
        loginButton: 'ログイン',
        logout: 'ログアウト',
        invalidEmail: '無効な電子メール形式',
        invalidFormatPassword: 'パスワードの形式が正しくありません',
        forgotPassword: 'パスワードをお忘れですか',
        passwordRecovery: 'パスワードの復元',
        passwordRecoveryTitle: 'ご指定のメールアドレスに手紙をお送りします',
        sendLetter: '手紙を出す',
        userExists: 'このメールアドレスを持つユーザーが存在します',
        userNotExists: 'このメールアドレスを持つユーザーは存在しません',
        passwordResetToMail: 'パスワードをリセットする手順は電子メールで送信されました。',
        passwordValidation: '8 ～ 20 個のラテン文字または数字を含める必要があります',
        invalidPassword: 'パスワードが間違っています',
        sessionNotFound: 'セッションが見つかりません',
        mismatchPassword: 'パスワード！もう一度やり直してください',
        rememberPassword: 'パスワードを覚えた',
        restore: '復元する',
        accExist: 'アカウントを持っています',
        confirmationCode: 'メールで送られてきた確認コードを入力してください',
        code: '確認コード',
        send: '送信',
        confirmation: '確認する',
        resend: '再送信',
        codeIsValid: 'コードは有効です',
        codeNotValid: 'コードが無効です',
        newPassword: '新しいパスワードを入力',
        passwordUsedBefore: 'パスワードは以前に使用されています',
        passwordUpdatedSuccessfully: 'パスワードが正常に更新されました',
        enterEmail: 'メールアドレスを入力してください',
        enterPassword: 'パスワードを入力する',
        enterPasswordAgain: 'パスワードをもう一度入力してください',
        notRobot: 'あなたがロボットではないことを証明してください。',
        deletionPersonalData: '個人データを削除するには、電子メールでメッセージを送ってください。',
    },
    profile: {
        edit: 'プロファイル編集',
        remove: 'アカウントを削除する',
        projectName: 'プロジェクト名',
        editing: 'プロフィールを編集する',
        name: 'あなたの名前',
        lastName: 'あなたの名字',
        inputPattern: '2文字から10文字まで',
        purchases: '購入がありません',
        settings: '設定',
        transactions: '取引',
        support: 'サポート',
    },
    payment: {
        toPay: '支払う',
        method: '支払方法',
        pay: '支払う',
        purchases: '購入品',
        paymentMethod: '支払方法',
        debitCard: 'デビットカード',
        copy: '支払い ID がコピーされました!',
        cancellation: '支払いをキャンセルしてもよろしいですか?',
        email: '領収書を受け取るためのメール',
        status: {
            none: 'なし',
            pending: '保留中',
            paid: '支払済み',
            fail: '失敗',
        },
        state: {
            progress: '支払い処理中',
            wait: 'お待ちください',
            paid: '支払い済み',
            successful: '支払い成功',
            notPaid: '未払い',
            error: 'エラー',
            cancelled: '支払いキャンセル',
            cancel: 'キャンセル',
        },
    },
    games: {
        header: {
            buttonGuest: 'ゲスト',
            buttonLogin: 'ログイン',
            buttonLogout: 'ログアウト',
        },
        buttonPlay: 'プレイ',
        buttonInDevelop: '開発中',
    },
    support: {
        noPurchases: "まだ購入がありません",
        contactSupport: "サポートに問い合わせる",
        paymentId: "支払いID",
        userId: "ユーザーID",
        requestReason: "問い合わせの理由",
        feedbackEmail: "返信用メールアドレス",
        dropNotCredited: "ドロップが付与されていません",
        other: "その他",
        success: 'リクエストが受け入れられました',
        successText: 'お問い合わせを受け取りました。近日中にメールでご連絡いたします。',
        createTicket: 'お問い合わせを作成',
        ticketTitle: '私のチケット',
        requestDescription: '問題についてできるだけ詳しくご説明ください',
        requestTitleDescription: 'タイトルを入力してください',
        ticketTitlePlug: 'からのリクエスト',
        errorMessageFormat: 'サポートされていないビデオ形式',
        errorMessageSize: 'ファイルサイズが制限を超えています',
        you: 'あなた',
        subject: '依頼の件名',
        description: '説明',
        descriptionEmptyWarning: '問題の説明を記入してください',
        conversationEnded: '会話が終了しました',
        system: 'システムメッセージ',
        messageDelivered: 'メッセージがシステムによって受信されました',
    },
    receipt: {
        generation: 'レシートを生成中',
        wait: '少し時間がかかる場合があります。しばらくお待ちください。'
    },
    blocked: {
        title: 'アクセスが制限されています',
        ip: 'お住まいの地域からのサイトへのアクセスは制限されています。ご不便をおかけして申し訳ありませんが、ご理解のほどよろしくお願いいたします。'
    },
}

export default {
    translation,
}
